import React from 'react';

import Category from "./Category";
import AssetGroup from "./AssetGroup";

function Component({ component, className, selectedAsset, hoveredAsset, onSelectAsset, onHoverAsset }) {
  return (
    <>
      {
        (component.assets || []).length > 0 ?
          // These assets have no group. Let's create a fake one to hold them.
          <AssetGroup
            group={{
              assets: component.assets,
              name: 'Assets',
              icon: 'fa-cubes',
              pseudo: true,
            }}
            selectedAsset={selectedAsset}
            hoveredAsset={hoveredAsset}
            onSelectAsset={onSelectAsset}
            onHoverAsset={onHoverAsset}
          />
          :
          null
      }
      {
        (component.assetGroups || []).map(
          (agc) => (
            <Category
              key={agc.id}
              category={agc}
              selectedAsset={selectedAsset}
              hoveredAsset={hoveredAsset}
              onSelectAsset={onSelectAsset}
              onHoverAsset={onHoverAsset}
            />
          )
        )
      }
    </>
  )
}

export default Component
